import IComponent from "components/commons/IComponent";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import Button from "@material-ui/core/Button";
import DrawTool from "components/commons/DrawTool";
import config_zoomto from "./config_zoomto";
import { saveGraphicSearchInput } from "store/globalSlice";
import "./ZoomTo.scoped.css";
import UserGroup from "./UserGroup";
import GetArcGISToken from "utils/GetArcGISToken";
import FilterList from "components/commons/FilterList";
let LAYER_SEARCH_SCHEMA = undefined;
let SEARCH_LAYER_ID = undefined;
class ClassName extends IComponent {
  constructor(props) {
    super(props);
    if (typeof LAYER_SEARCH_SCHEMA === "undefined") {
      console.debug("Preparing predefined list");
      let searchData = UserGroup["Group" + GetArcGISToken.user.userGroup];
      searchData.Schemas.push({
        Text: "UAV",
        Value: "UAV",
        mapType: 3,
        GraphicalSearchs: [{ Text: "UAV" }],
      });
      LAYER_SEARCH_SCHEMA = searchData;
      // Look for the default layer IDs
      searchData.Schemas.forEach((i) => {
        let defaultIdx = i.GraphicalSearchs.findIndex((j) => j.Default);
        if (defaultIdx > -1) {
          i.defaultLayer = defaultIdx;
        }
        i.GraphicalSearchs = i.GraphicalSearchs.map((i) => i.Text);
      });

      Promise.all(
        this.$config.mapList.layer2D.map(
          (i) =>
            new Promise((resolve) => {
              i.layer.when(resolve);
            })
        )
      ).then(
        (() => {
          // Update the layer IDs in the search config file to match the actual map services
          SEARCH_LAYER_ID = searchData.Schemas.reduce((p, c, i) => {
            let layer = this.$config.mapList.layer2D.find(
              (a) => a.layer.url.indexOf(c.Text) > -1
            )?.layer;
            if (!layer) p[c.Text] = [];
            else {
              p[c.Text] = c.GraphicalSearchs.map(
                (a) => layer.sourceJSON.layers.find((b) => b.name === a)?.id
              );
            }

            return p;
          }, {});
          config_zoomto.GRAPHICAL_SEARCH_LIST.forEach((i) => {
            i.allowSavePdf =
              i.allowSavePdf ||
              config_zoomto.allowExportToPDF.find((j) => {
                if (j === i.name) return true;
                else {
                  let name = i.name;
                  let match = name.match(/^(.*?)s$|^(.*?) \(.*?\)$/);
                  return match && (match[1] === j || match[2] === j);
                }
              });
          });
          console.debug(config_zoomto, LAYER_SEARCH_SCHEMA, SEARCH_LAYER_ID);
        }).bind(this)
      );
    }

    this.state = {
      searchInput: {
        bufferSize: 0,
        searchCategory: LAYER_SEARCH_SCHEMA.Schemas[0].defaultLayer,
        searchScheme: 0,
        customSearchList: {},
        ...props.reduxStore.global.graphicSearchInput,
      },
      geometry: null,
      searchableSchema: LAYER_SEARCH_SCHEMA
        ? LAYER_SEARCH_SCHEMA.Schemas.filter(
            (i) => props.mapType === 3 || i.mapType !== 3
          ).map((i) => i.Text)
        : [],
    };
    if (
      props.mapType === 2 &&
      LAYER_SEARCH_SCHEMA.Schemas[this.state.searchInput.searchScheme].Text ===
        "UAV"
    ) {
      this.state.searchInput.searchScheme = 0;
    }

    this.state.customSearchList = UserGroup.CustomLayerInfos.map((i) => ({
      ...i,
      optionName: i.LayerName,
      checked: i.LayerName in this.state.searchInput.customSearchList,
    }));
  }
  componentDidMount() {}
  componentWillUnmount() {
    let customSearchList = this.state.customSearchList.reduce((p, c, i) => {
      if (c.checked) p[c.optionName] = 1;
      return p;
    }, []);
    this.state.searchInput.customSearchList = customSearchList;
    this.props.reduxCallProxy(saveGraphicSearchInput, this.state.searchInput);
  }
  onChangeHandler(field, value, values) {
    let newState = { ...this.state.searchInput };
    newState[field] = value;
    if (field === "searchScheme")
      newState.searchCategory =
        LAYER_SEARCH_SCHEMA.Schemas[value].defaultLayer || 0;
    console.debug(newState);
    this.setState({
      searchInput: newState,
    });
  }
  onGraphicSearch() {
    if (!this.state.geometry) return;
    let { searchScheme, searchCategory } = this.state.searchInput;
    let schemeInfo = LAYER_SEARCH_SCHEMA.Schemas[searchScheme];
    let searchLayer = schemeInfo.Text;
    let searchTitle = schemeInfo.GraphicalSearchs[searchCategory];
    let searchLayerId = SEARCH_LAYER_ID[searchLayer][searchCategory];

    if (searchTitle === "CUSTOM") {
      let customSearch = this.state.customSearchList.reduce((p, c, i) => {
        if (!c.checked) return p;
        if (!(c.ServiceName in p)) p[c.ServiceName] = [];
        p[c.ServiceName].push(c.LayerIndex);
        return p;
      }, {});
      customSearch = Object.keys(customSearch).map((i, j) => ({
        name: "CUSTOM",
        layer: i,
        layerId: customSearch[i],
      }));
      this.props.onGraphicSearch(customSearch, this.state.geometry);
      return;
    }

    let searchInfo =
      config_zoomto.GRAPHICAL_SEARCH_LIST.find((i) => i.name === searchTitle) ||
      {};
    if (typeof searchInfo.type === "undefined")
      searchInfo = {
        ...searchInfo,
        name: searchTitle,
        layer: searchLayer,
        layerId: searchLayerId,
      };

    console.debug(searchInfo);

    this.props.onGraphicSearch(searchInfo, this.state.geometry);
  }
  onDrawCompletedHandler(geometry) {
    this.setState({ geometry }, () => this.onGraphicSearch());
  }
  onDisplayCustomSelectBox() {
    this.props.showDialog({
      isOpen: true,
      type: "info",
      title: "Custom Search",
      content: (
        <FilterList
          listData={this.state.customSearchList}
          customFilters={[
            {
              label: "GCDIST 1",
              eval: (item) => item.GCDIST1,
            },
          ]}
        />
      ),
      onDialogOk: () => {},
    });
  }
  render() {
    const GraphicSearch = { height: "50px", padding: "15px 20px" };
    const ZoomToLocation = { height: "70px" };
    const ZoomToLocation_Padding = { padding: "25px 20px" };
    const ZoomToLocation_Margin = { margin: "20px 0px 0px 0px" };
    let { searchScheme, searchCategory } = this.state.searchInput;
    let schemeInfo = LAYER_SEARCH_SCHEMA?.Schemas[searchScheme];
    let searchTitle = schemeInfo?.GraphicalSearchs[searchCategory];
    return (
      <div>
        <div className="SubPanelTitle" style={GraphicSearch}>
          Graphic Search
        </div>
        <div className="SubPanelContent" style={ZoomToLocation_Padding}>
          <div className="EqualWidthChildren" style={{ margin: "0px" }}>
            <EditableDatagridCell
              cellInfo={{
                colDef: {
                  field: "searchScheme",
                  dataType: "dropdown",
                  values: this.state.searchableSchema,
                  required: true,
                },
                row: this.state.searchInput,
              }}
              onChange={this.onChangeHandler.bind(this)}
            />
          </div>
          <div className="EqualWidthChildren" style={ZoomToLocation_Margin}>
            <EditableDatagridCell
              cellInfo={{
                colDef: {
                  field: "searchCategory",
                  dataType: "dropdown",
                  values:
                    LAYER_SEARCH_SCHEMA?.Schemas[
                      this.state.searchInput?.searchScheme
                    ].GraphicalSearchs || [],
                  required: true,
                },
                row: this.state.searchInput,
              }}
              onChange={this.onChangeHandler.bind(this)}
            />
            {searchTitle === "CUSTOM" && (
              <Button
                style={{ height: "59px" }}
                variant="outlined"
                onClick={() => this.onDisplayCustomSelectBox()}
              >
                ...
              </Button>
            )}
          </div>
          <div className="EqualWidthChildren" style={ZoomToLocation_Margin}>
            <div className="Shrink3 BufferText" style={{ height: "58px" }}>
              Buffer (m)
            </div>
            <EditableDatagridCell
              cellInfo={{
                colDef: {
                  field: "bufferSize",
                  dataType: "number",
                  values: [],
                  hint: "0",
                },

                row: this.state.searchInput,
                key: "graphic_text_01",
              }}
              onChange={this.onChangeHandler.bind(this)}
            />
          </div>
          <div className="EqualWidthChildren" style={ZoomToLocation_Margin}>
            <DrawTool
              mapView={this.props.mapView}
              onDrawComplete={this.onDrawCompletedHandler.bind(this)}
              bufferSize={this.state.searchInput.bufferSize}
              excludedList={{ text: 1 }}
            />
            {/* <Button
              classes={{ root: "actionBtn" }}
              variant="contained"
              onClick={() => this.onGraphicSearch()}
              disabled={!this.state.geometry}
            >
              <span className="icn_menu_search icon_s" />
            </Button> */}
          </div>
        </div>
      </div>
    );
  }
}

export default ClassName;
